import React from 'react';
import '../styles/PrivacyPage.css';

const PrivacyPage = () => {
  // プライバシーポリシーのテキスト（法務から提供されるテキストをここに貼り付け）
  const privacyText = `株式会社STPR（以下「当社」といいます）は、当社が運営する「STPR配信スケジュール」（以下「本サービス」）におけるユーザーの個人情報の取扱いについて、以下のとおりプライバシーポリシーを定めます。
<h2>1. 取得する情報</h2>
本サービスでは、YouTube APIサービスを通じて以下の情報を取得する場合があります：
<ul>
<li>チャンネルID</li>
<li>動画ID</li>
<li>再生数</li>
<li>同時接続数（ライブ配信中の同時視聴者数）</li>
</ul>
また、Google Analytics により、サイトの利用状況に関するCookie情報を取得することがあります。

<h2>2. 利用目的</h2>
取得した情報は、以下の目的で利用されます：
<ul>
<li>配信スケジュールの自動表示</li>
<li>ランキング機能の提供・改善</li>
<li>ユーザー体験の向上およびアクセス解析</li>
</ul>

<h2>3. 情報の保存および管理</h2>
取得した情報は適切に管理され、不正アクセス、漏洩、改ざん等を防止するための対策を講じます。保存期間は目的達成に必要な期間とし、その後は削除または匿名化されます。

<h2>4. 第三者提供・共有について</h2>
取得したデータは、特別な事情がない限り、外部の第三者に提供されることはありません。業務委託先等に提供する場合は、適切な契約・監督のもとで行います。

<h2>5. Cookie・Google Analytics の使用について</h2>
本サービスでは、Googleによるアクセス解析ツール「Google Analytics」を使用しています。Google Analyticsはトラフィックデータの収集のためにCookieを使用しています。データは匿名で収集されており、個人を特定するものではありません。
Googleのプライバシーポリシーに関しては、以下をご確認ください：
http://www.google.com/policies/privacy

<h2>6. YouTube API Services の利用について</h2>
本サービス（STPR配信スケジュール）は、Google が提供する YouTube API Services を利用します。 本サービスを利用することで、ユーザーは YouTube 利用規約（https://www.youtube.com/t/terms）および Google プライバシーポリシー（https://www.google.com/policies/privacy）に従うことに同意したものとみなされます。

<h3>取得する情報</h3>
当社は、ユーザーの氏名・メールアドレス・電話番号等の個人情報を取得・保存・利用することはありません。
当社が本サービスの提供のために取り扱うのは、YouTube API から取得する以下の公開情報のみです。

<ul>
<li>チャンネルID / チャンネル名</li>
<li>チャンネル画像URL / サムネイルURL</li>
<li>動画ID / タイトル / 説明文</li>
<li>配信予定日時・公開日時</li>
<li>再生数・同時接続数などの公開統計情報</li>
</ul>

<h3>利用目的</h3>
これらの情報は、配信スケジュール表示、ランキング機能の提供、サービス改善など、ユーザー体験の向上を目的としてのみ利用します。

<h3>アカウント連携（OAuth）について</h3>
本サービスは、ユーザーの Google アカウントと OAuth による連携を行いません。
そのため、ユーザー個人に紐づくアクセストークンや非公開データを取得・保存することはありません。

<h3>保存期間・管理方法</h3>
取得した YouTube API データは、最新性を保つため定期的に更新されます。
保持は目的達成に必要な期間に限り、その後は速やかに削除または匿名化されます。
また、取得データは不正アクセスや漏洩を防ぐため、適切なセキュリティ対策を講じた上で管理されます。

<h3>第三者提供について</h3>
法令に基づく場合を除き、当社は YouTube API から取得した情報を第三者へ提供することはありません。

<h3>ユーザーによるアクセス権の管理</h3>
ユーザーは Google アカウントの設定画面（https://security.google.com/settings/security/permissions）から、当社による YouTube API データへのアクセス権をいつでも取り消すことができます。

<h2>7. Cookieおよび関連技術の使用</h2>
本サービスは、Cookieやそれに準ずる技術を活用しています。これらを用いることで、サービスのご利用傾向を分析し、皆様により快適な体験を提供できるよう改善に努めています。Cookieの受け入れを望まれない方は、お使いのインターネットブラウザから設定変更が可能です。ただし、機能を制限した場合、本サービスの一部がご利用できなくなることがあります。
サービス向上を目的として、Google Analyticsによる分析を行っています。この仕組みでは、Cookieを通じて匿名化された形でアクセス情報を収集しており、個人の特定は行いません。詳しい仕組みについては、Google アナリティクスの利用規約（https://marketingplatform.google.com/about/analytics/terms/jp/）やGoogleのプライバシーポリシー（https://policies.google.com/privacy?gl=jp）でご確認いただけます。
場合によっては、Cookie情報とユーザーアカウントを紐付けて管理することがございます。
また、Google広告の拡張コンバージョン（https://support.google.com/google-ads/answer/9888656?hl=ja）という仕組みを導入する場合があります。これは、お預かりしているお名前やご連絡先などの情報を特殊な形式に変換（ハッシュ化）して、より適切な広告表示や広告効果の分析に活用するものです。変換された情報は、Google側で広告関連の用途にのみ使用されます。この機能を無効にしたい場合は、以下のページ（https://support.google.com/My-Ad-Center-Help/answer/12155764?hl=ja）から設定していただけます。

<h2>8. 他社サービスとの接続</h2>
本サービスでは、機能の一部でYouTube APIを利用させていただいております。Googleアカウントの設定画面（https://security.google.com/settings/security/permissions）から、いつでも当社のアクセス許可を解除できます。なお、解除された場合は関連する機能が使えなくなりますので、ご注意ください。

<h2>9. お問い合わせ窓口</h2>
プライバシーポリシーに関するお問い合わせは、以下のメールアドレスまでご連絡ください。
メールアドレス：info@stprcorp.com

2025年8月1日策定
`;

    // URLを自動的にリンクに変換し、HTMLを処理する関数
  const processTextWithHtml = (text) => {
    // 日本語の括弧や句読点でURLを終了させる正規表現
    const urlRegex = /(https?:\/\/[^\s）)）」』】〕｠、。，．]+)/g;
    
    // URLをリンクタグに置換
    let processedText = text.replace(urlRegex, (url) => {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
    
    // 終了タグ後の改行を1つ削除
    processedText = processedText.replace(/(<\/[^>]+>)\n/g, '$1');
    
    // 改行を<br>タグに変換（HTMLタグの直前は除く）
    processedText = processedText.replace(/\n(?!<)/g, '<br>');

    return processedText;
  };

  return (
    <div className="privacy-page">
      <h1 className="privacy-title">プライバシーポリシー</h1>
      <div className="privacy-content">
        <div 
          className="privacy-text"
          dangerouslySetInnerHTML={{ __html: processTextWithHtml(privacyText) }}
        />
      </div>
    </div>
  );
};

export default PrivacyPage;
